export default `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9"><path d="M7.18,7.62L3.03,2.79c-.6-.7-.1-1.79,.82-1.79H12.14c.93,0,1.42,1.09,.82,1.79l-4.14,4.83c-.43,.5-1.21,.5-1.64,0Z" fill="currentColor"/></svg>`
